import type { ResumeData } from '../../ai-agent/canvas/CanvasProvider';
import type { CanonicalResume } from '../schemas/resumeSchema';

/** Build canonical JSON directly from structured profile data — zero regex parsing. */
export function resumeDataToCanonical(data: ResumeData): CanonicalResume {
  return {
    personalInfo: {
      fullName: data.name?.trim() || '',
      email: data.contact?.email?.trim() || '',
      phone: data.contact?.phone?.trim() || '',
      location: data.contact?.location?.trim() || '',
      linkedin: data.contact?.linkedin?.trim() || undefined,
      github: data.contact?.github?.trim() || undefined,
    },
    professionalSummary: (data.summary || data.headline || '').trim(),
    workExperience: (data.experience ?? []).map((exp) => ({
      title: exp.title?.trim() || 'Role',
      company: exp.company?.trim() || '',
      location: exp.location?.trim() || undefined,
      startDate: exp.startDate?.trim() || '',
      endDate: exp.endDate?.trim() || 'Present',
      highlights: (exp.bullets ?? []).map((b) => b.trim()).filter(Boolean),
    })),
    education: (data.education ?? []).map((edu) => ({
      degree: edu.degree?.trim() || '',
      institution: edu.institution?.trim() || '',
      year: edu.year?.trim() || '',
    })),
    skills: {
      technical: (data.skills ?? []).map((s) => s.trim()).filter(Boolean),
      frameworksAndTools: [],
      managementAndDomain: [],
    },
    certifications: (data.certifications ?? []).map((c) => c.trim()).filter(Boolean),
  };
}
